import {createUseStyles} from "react-jss";
import {colors} from "constants/colors";

const styles = createUseStyles({
  loyaltyPoints: {
    display: 'flex',
    columnGap: 10,
  },
  loyaltyPointsText: {
    margin: 0,
    'h6&': {
      fontSize: 14,
      color: colors.lightBlack,
    },
    'p&': {
      fontSize: 12,
      color: colors.lightBlack,
      '.disabled &': {
        color: colors.error900
      }
    }
  },
  loyaltyPointInfo: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around'
  },
  loyaltyPointsIconContainer: {},
  loyaltyPointProgress: {
    '--bs-progress-height': '8px',
    '--bs-progress-bar-bg': colors.darkBlue,
    "& .progress-bar": {
      borderRadius: "6px"
    },

    '.disabled &': {
      '--bs-progress-bar-bg': colors.primary200Blue,
    }
  }
});

export default styles;
